<script lang="ts">
// 组件名称，用于 keep-alive 的 include 属性匹配
// 必须与 App.vue 中 keepAliveComponents 数组中的名称一致
export default {
  name: 'NewsView'
}
</script>
<template>
  <div class="news">
    <div class="news-banner">
      <img :src="loadUrl.news" />
      <div>{{ store.state.programmeIndex == 6 ? '行业新闻' : '公司新闻' }}</div>
    </div>
    <div class="news-content">
      <div v-for="(item, index) in newsList" :key="index" @click="toOtherPath(item.relatedHtmlId, item.title)">
        <div>
          <img :src="item.ossPath" />
        </div>
        <div>
          <div class="title">{{ item.title }}</div>
          <div class="introduction">{{ item.introduction }}</div>
          <div class="createTime">{{ formatDate(item.newsTimestamp) }}</div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <div class="prev" @click="changeData(Math.max(0, paginationIndex - 1) + 1)"></div>
      <div @click="changeData(item)" v-for="(item, index) in paginationValue"
        :class="paginationIndex == index ? 'active' : ''" :key="item">{{
          item }}</div>
      <div class="next" @click="changeData(Math.min(paginationIndex + 1, paginationValue - 1) + 1)"></div>
    </div>
    <!-- <contact-us></contact-us> -->
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import store from '@/store';
// import ContactUs from '@/components/ContactUs.vue'
import { asynchronousRetrieval } from '@/utils'

const loadUrl: any = ref({})
const newsListAll: any =  ref([])
const newsList: any = ref([])
const paginationIndex = ref(0)
const paginationValue = ref(1)

const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
  store.state.pageTitleStr = `新闻中心 / 新闻详情 / ${title}`
}

const changeData = (value: number) => {
  paginationIndex.value = value - 1;
  newsList.value = [...newsListAll.value].slice((value - 1) * 8, value * 8)
}

const formatDate = (timestamp: number) => {

   const date = new Date(timestamp)
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = date.getHours();
    const mx = date.getMinutes();
    const s = date.getSeconds();

    return `${y}-${m}-${d}`
}

const getData = (columnId: number) => {
  selectCommonElement({ columnId, appId: 2 }).then((res: any) => {
    newsListAll.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0))
    newsList.value = [...newsListAll.value].slice(paginationIndex.value * 8, (paginationIndex.value + 1) * 8)
    paginationValue.value = Math.ceil(newsListAll.value?.length / 8) || 0
  })
}

onMounted(async () => {
  // 条件判断：只有当图片未加载时才请求图片资源
  // 避免重复加载图片，保持缓存状态
  if (!loadUrl.value.news) {
    const news: any = await asynchronousRetrieval('webimg/images/about_us/news.png');
    loadUrl.value = { news }
  }

  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  const columnId = +path.query.type || 5
  
  // 条件判断：只有当数据为空时才请求接口
  // 因为组件被 keep-alive 缓存，再次进入页面时 onMounted 仍会执行
  // 但数据已经存在，不需要重新请求
  if (newsListAll.value.length === 0) {
    getData(columnId);
  }
})
watch(() => store.state.programmeIndex, (newState: any) => {
  getData(newState)
})
</script>
<style scoped lang="less">
.news {
  min-height: calc(100vh - 400rem);
  background: #EFEFEF;

  .news-banner {
    position: relative;
    height: 21.875vw;
    line-height: 26.302vw;
    text-align: center;
    font-weight: 600;
    font-size: 3.33vw;
    color: #FFFFFF;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    &>div {
      position: relative;
      z-index: 1;
    }
  }

  .news-content {
    padding-top: 24rem;
    padding-bottom: 50rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;

    &>div {
      width: 1120rem;
      height: 353rem;
      background: #FFFFFF;
      border-radius: 12rem;
      margin-bottom: 24rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 24rem;
      box-sizing: border-box;
      cursor: pointer;

      &>div:first-child {
        width: 542rem;
        height: 305rem;
        background: #D8D8D8;
        border-radius: 12rem;
        // border: 1px solid #979797;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      &>div:last-child {
        width: 503rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;

        .title {
          font-weight: bold;
          font-size: 24rem;
          color: #414141;
          margin-bottom: 16rem;
          line-height: 40rem;
        }

        .introduction {
          font-weight: 400;
          font-size: 18rem;
          color: #414141;
          margin-bottom: 26rem;
          line-height: 30rem;
        }
      }
    }
  }

  .pagination {
    margin: -50rem 0 67rem;
    display: flex;
    justify-content: center;
    align-items: center;

    &>div {
      width: 24rem;
      height: 24rem;
      line-height: 24rem;
      border-radius: 2rem;
      font-weight: 400;
      font-size: 14rem;
      color: #999999;
      margin: 0 5rem;
      text-align: center;
      cursor: pointer;
    }

    &>div.active {
      background: #F7F7F7;
      color: #414141;
    }

    .prev {
      width: 16rem;
      height: 16rem;
      background-image: url(~@/assets/images/solution/left-c.png);
      background-size: 100% 100%;
    }

    .next {
      width: 16rem;
      height: 16rem;
      background-image: url(~@/assets/images/solution/left-c.png);
      background-size: 100% 100%;
      transform: rotate(180deg);
    }
  }
}
</style>
